<h5 mat-dialog-title i18n>Lead Source Report</h5>
<div mat-dialog-content>
  <form #parameterForm="ngForm" (ngSubmit)="runReport(parameterForm)">
    <div *ngIf="data.leadSource.showMargins" class="control-wrapper">
      <span i18n>Show: Gross Margin</span>
      <input type="checkbox" name="grossMargin" id="grossMargin" [(ngModel)]="data.leadSource.grossMargin">
    </div>
    <hr />
    <p i18n>Please define the filters below</p>
    <div class="form-group row">
      <div class="col-sm-6">
        <div class="control-wrapper">
          <label for="salespersonId" class="col-sm-3 col-form-label" i18n>Salesperson</label>
          <select name="salespersonId" id="salespersonId"
                  [(ngModel)]="data.leadSource.salespersonId" #salespersonId="ngModel"
                  class="form-control select-bidit">
            <option value="null" i18n>All</option>
            <option *ngFor="let salesperson of data.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
          </select>
        </div>
        <div class="control-wrapper">
          <label for="salespersonId" class="col-sm-3 col-form-label" i18n>Choose Lead Sources to Evaluate</label>
          <mat-select multiple required class="form-control" [(value)]="data.leadSource.leadSourceTypes">
            <mat-option *ngFor="let leadSourceType of data.leadSourceTypes" [value]="leadSourceType.leadSourceType_ID">{{leadSourceType.leadSourceType_Desc}}</mat-option>
          </mat-select>
          <input type="hidden" name="validation" id="validation"
                 class="form-control"
                 [(ngModel)]="data.validation" #validation="ngModel" />
          <div [hidden]="!parameterForm.submitted || validation.valid"
               class="alert alert-danger" i18n>
            Lead Source Required
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <p i18n>Define Time Frame</p>
        <div class="control-wrapper">
          <label for="year" class="col-sm-3 col-form-label" i18n>Year</label>
          <select name="year" id="year"
                  [(ngModel)]="data.leadSource.year" #year="ngModel"
                  class="form-control select-bidit">
            <option *ngFor="let year of data.years" [ngValue]="year">{{year}}</option>
          </select>
        </div>
        <div class="control-wrapper">
          <label for="startMonth" class="col-sm-3 col-form-label" i18n>Start Month</label>
          <select name="startMonth" id="startMonth"
                  [(ngModel)]="data.leadSource.startMonth" #startMonth="ngModel"
                  class="form-control select-bidit">
            <option *ngFor="let month of data.months" [ngValue]="month.MonthNum">{{month.MonthName}}</option>
          </select>
        </div>
        <div class="control-wrapper">
          <label for="endMonth" class="col-sm-3 col-form-label" i18n>End Month</label>
          <select name="endMonth" id="endMonth"
                  [(ngModel)]="data.leadSource.endMonth" #endMonth="ngModel"
                  class="form-control select-bidit">
            <option *ngFor="let month of data.months" [ngValue]="month.MonthNum">{{month.MonthName}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="form-group">
      <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
      <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
  </form>
</div>
